<ecoupon-shared-ui-lip-ecoupon-information [data]="eCouponMessage()"></ecoupon-shared-ui-lip-ecoupon-information>
